<div class="center">
  <mat-card appearance="outlined" id="style-4" class="cardcomponentMasks">
    <div class="arx-calendar">
      <iframe
        src="https://calendar.google.com/calendar/embed?height=1300&amp;wkst=2&amp;bgcolor=%23D81B60&amp;ctz=Europe%2FRome&amp;src=Y180Mzl0Y3VvYTg4ZnRodHBtdDc4Z2tlZjAyMEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&amp;color=%23D81B60&amp;showTitle=0&amp;showPrint=0&amp;showCalendars=1&amp;title=Trattative%20commerciali"
        style="border:solid 1px #777" width="1500" height="800" frameborder="0" scrolling="no"></iframe>
    </div>
  </mat-card>
</div>
